module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/PoOjeh/tc-custom/9781634868457.jpg?1723406934713",
      "alt": "This image is the cover for the book Framed for Murder"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Framed for Murder\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("My name is Charlie English. I'm thirty-eight and homeless, so when a man offered me forty bucks to deliver a message and another forty when I had, I jumped at the chance. I shouldn't have. I walked into the house -- and a murder scene -- barely getting away before the cops arrived."), _c('br'), _c('br'), _vm._v("I needed to get out from under the frame, and knew a private detective who might be willing to help me. There’s one problem, though. He’s my ex-lover, which could make things dicey."), _c('br'), _c('br'), _vm._v("He’s less than happy to see me when I show up at his office ... until I tell him why I’m there. That piques his interest. Now it’s a case of finding out who the dead man was, who killed him, and proving it wasn't me. Can we succeed ... while dealing with our renewed interest in each other?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Edward Kendrick\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0